const setNewDate = (
  dt0: Date | undefined | null,
  dt1: Date | undefined | null,
  isDate: boolean,
) => {
  if (!dt1) return null;

  let year0;
  let month0;
  let day0;
  let hour0;
  let min0: number;
  let year1;
  let month1;
  let day1;
  let hour1;
  let min1: number;

  let setTZ = true;

  if (!dt0 || isNaN(dt0.getTime())) {
    year0 = 1970;
    month0 = 0;
    day0 = 1;
    hour0 = 0;
    min0 = 0;
    if (isDate) setTZ = false;
  } else {
    const isoTime0: string = typeof dt0 === 'string' ? dt0 : dt0.toISOString();
    const date0: string =
      isoTime0.split('T').length > 0 ? isoTime0.split('T')[0] : '1970-01-01';
    const time0: string =
      isoTime0.split('T').length > 1 ? isoTime0.split('T')[1] : '00:00:0.000Z';
    const ymd0: string[] =
      date0.split('-').length === 3 ? date0.split('-') : ['1960', '0', '1'];
    const hm0: string[] =
      time0.split(':').length > 1 ? time0.split(':') : ['00', '00'];
    year0 = parseInt(ymd0[0]);
    month0 = parseInt(ymd0[1]) - 1;
    day0 = parseInt(ymd0[2]);
    hour0 = parseInt(hm0[0]);
    min0 = parseInt(hm0[1]);
  }

  const isoTime1 = typeof dt1 === 'string' ? dt1 : dt1.toISOString();
  const date1: string =
    isoTime1.split('T').length > 0 ? isoTime1.split('T')[0] : '1970-01-01';
  const time1: string =
    isoTime1.split('T').length > 1 ? isoTime1.split('T')[1] : '00:00:0.000Z';
  const ymd1: string[] =
    date1.split('-').length === 3 ? date1.split('-') : ['1960', '0', '1'];
  const hm1: string[] =
    time1.split(':').length > 1 ? time1.split(':') : ['00', '00'];

  if (isDate) {
    year1 = parseInt(ymd1[0]); // v.getFullYear();
    month1 = parseInt(ymd1[1]) - 1; // v.getMonth();
    day1 = parseInt(ymd1[2]); // v.getDay();
    hour1 = hour0;
    min1 = min0;
  } else {
    year1 = year0;
    month1 = month0;
    day1 = day0;
    hour1 = parseInt(hm1[0]); // (v as Date).getHours();
    min1 = parseInt(hm1[1]); // (v as Date).getMinutes();
  }
  const newDate = new Date(year1, month1, day1, hour1, min1, 0);

  // adjusts timezone
  if (setTZ)
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());

  return newDate;
};

const getISODateTimeString = (date: string | number) => {
  if (typeof date === 'undefined') {
    return '-';
  }
  const moment =
    typeof date === 'string' ? new Date(date) : new Date(date * 1000);
  return `${moment.toLocaleString('en-GB', { timeZoneName: 'short' })}`;
};

export { setNewDate, getISODateTimeString };
